<template>
    <x-container fluid app-width>
        <x-layout>
            <x-flex>
                <template v-if="loading">
                    <loading-spinner />
                </template>

                <x-container v-else fluid class="summary-container">
                    <x-layout>
                        <x-flex>
                            <firm-order-builder
                                v-if="currentStep === 1"
                                :submission.sync="submission"
                                :current-step="currentStep"
                                :pricing="pricing"
                                :draft-firm-order="draftFirmOrder"
                                @firm-order:navigate-to="goToStep"
                            />

                            <firm-order-confirmation
                                v-show="currentStep === 2"
                                :submission.sync="submission"
                                :current-step="currentStep"
                                :pricing="pricing"
                                :draft-firm-order="draftFirmOrder"
                                :cities="cities"
                                :firmOrder="firmOrder"
                                @firm-order:navigate-to="goToStep"
                            />

                            <broker-firm-order-summary
                                v-if="currentStep === 3"
                                :current-step="currentStep"
                                :firmOrder="firmOrder.data"
                                @firm-order:navigate-to="goToStep"
                            />
                        </x-flex>
                    </x-layout>
                </x-container>
            </x-flex>
        </x-layout>
    </x-container>
</template>

<script>
    import FirmOrderBuilder from '~/components/Broker/FirmOrder/FirmOrderBuilder';
    import FirmOrderConfirmation from '~/components/Broker/FirmOrder/FirmOrderConfirmation';
    import StatusChip from '~/components/Shared/UIComponents/StatusChip';
    import BrokerFirmOrderSummary from './BrokerFirmOrderSummary';

    export default {
        name: 'BrokerFirmOrder',
        components: {
            FirmOrderBuilder,
            FirmOrderConfirmation,
            StatusChip,
            BrokerFirmOrderSummary
        },
        data() {
            return {
                loading: true,
                submission: {},
                cities: [],
                currentStep: 1,
                pricing: {
                    structure: 'vertical',
                    horizontalPrice: 0,
                    horizontalPercentageOfMargin: 0,
                    net_margin: null,
                    gross_margin: null,
                },
                draftFirmOrder: null,
                firmOrder: {},
            }
        },
        created() {
            this.fetchData();

            this.$eventBus.$on('submissionChanged', async() => {
                this.submission = (await axios.get(this.$root.api(`broker/submission/${this.$route.params.id}`))).data.data;
            });

            this.$eventBus.$on('brokerageChanged', async(offer) => {
                this.submission.offers.find(o => o.id === offer.id).brokerage = offer.brokerage;
            });

            this.$eventBus.$on('brokerSubmissionChanged', async () => {
                await this.loadSubmission();
            });
        },
        methods: {
            async fetchData() {
                const dataRequests = [];

                dataRequests.push(axios.get(this.$root.api('city')).then(res => {
                    this.cities = res.data.data
                }));

                dataRequests.push(axios.get(this.$root.api(`broker/submission/${this.$route.params.id}`)).then(res => {
                    const submission = res.data.data;

                    if (submission.net_margin === 0) {
                        this.pricing.net_margin = 0;
                    }

                    if (submission.gross_margin === 0) {
                        this.pricing.gross_margin = 0;
                    }

                    const isCaptiveReinsurance = submission.transaction_type === 'captive_reinsurance';

                    if (isCaptiveReinsurance) {
                        this.pricing.structure = 'horizontal';
                    }

                    submission.offers.forEach(offer => {
                        offer.is_selected = false;
                        offer.is_remove_selected = false;
                        offer.manual_estimated_premium = '';

                        // if the offer is offered, and is not a captive insurer's offer, adjust the line size percent and amount considering the retained percent and amount, if any
                        if (offer.status === 'offered' && !offer.captive_insurer_company_id) {
                            offer.adjusted_line_size_percent = Math.min(100, offer.line_size_percent);

                            //limit amount for captive and non-captive
                            const limitAmount = isCaptiveReinsurance ? submission.contract_value : submission.limit_of_liability;

                            offer.adjusted_line_size_amount = Math.min(offer.line_size_amount, limitAmount);
                            offer.adjusted_written_line_percent = null;
                        }

                        // offer.is_selected and subjectivity.checked need to be set here so they are reactive in child components
                        offer.subjectivities.forEach(subjectivity => {
                            subjectivity.selected = false;
                            subjectivity.editable = false;
                        });
                    });

                    this.submission = submission;
                }));

                dataRequests.push(axios.get(this.$root.api(`broker/firm-order/${this.$route.params.id}`)).then(res => {
                    const draft = res.data.data;
                    if (draft.status === 'draft' || (draft.status === 'cancelled' && draft.submission.is_manual_firm_order === 1)) {
                        this.draftFirmOrder = draft;
                    }
                }));

                axios.all(dataRequests).then(() => {
                    this.loading = false;
                });
            },
            goToStep(step) {
                if (step === -1) {
                    this.$router.push('/agent/dashboard');
                } else {
                    this.currentStep = step;
                }
            },
            async loadSubmission() {
                this.loading = true;

                await this.fetchData();

                this.loading = false;
            }
        }
    }
</script>
